module.exports = __webpack_public_path__ + "assets/img/benefit-gold-b5a449e8.png";